import Box from '@app/components/common/Box';
import { useLoadReportsChangeData } from '@westondev/tableturn-core';
import { useMatch, useParams } from 'react-router-dom';
import { getPathWithOrgData } from '@app/helpers/navigation';
import { useEffect, useState } from 'react';
import Tabs from '@app/components/common/Tabs';
import { IActiveTab } from '@app/components/common/Tabs/types';
import Divider from '@app/components/common/Divider';
import { displayFlexColumnStyles } from '@app/theme/commonStyles';
import CustomReportsCreator from './CustomReportsCreator';
import CustomReportsSettings from './CustomReportsSettings';
import Icon from '@app/components/common/Icon';

const bucket = 'customReports';

const AddEditCustomReports = () => {
  const id = useParams().id;
  const isAdd = useMatch(getPathWithOrgData('/reports/:bucket/add'));

  const [activeTab, setActiveTab] = useState<IActiveTab>({
    tabId: 1,
    subTabId: null,
  });

  const report = useLoadReportsChangeData<typeof bucket>(
    isAdd ? 0 : Number(id),
    bucket,
  );

  useEffect(() => {
    if (activeTab.tabId === 2) {
      document
        .getElementById('customReportOutlet')
        ?.style.setProperty('overflow-y', 'auto');

      document
        .getElementById('customReportLayout')
        ?.style.setProperty('overflow-y', 'auto');
    } else {
      document
        .getElementById('customReportOutlet')
        ?.style.setProperty('overflow-y', 'hidden');
      document
        .getElementById('customReportLayout')
        ?.style.setProperty('overflow-y', 'hidden');
    }
  }, [activeTab]);

  if (!report) return;

  return (
    <>
      <Box csx={[displayFlexColumnStyles, { marginBottom: '10px' }]}>
        <Tabs
          fillContent
          activeTab={activeTab}
          csx={{
            padding: '0px',
            height: 'auto',
            boxShadow: 'none',
            backgroundColor: 'transparent',
          }}
          data={[
            {
              name: 'Customize Report',
              id: 1,
              buttonProps: {
                csx: { height: '40px' },
                icon: <Icon name="MdInsertDriveFile" />,
                iconPosition: 'left',
              },
            },
            {
              name: 'Report Settings',
              id: 2,
              buttonProps: {
                csx: { height: '40px' },
                icon: <Icon name="MdSettings" />,
                iconPosition: 'left',
              },
            },
          ]}
          onSelectedTabChange={(tabId, subTabId) => {
            setActiveTab({
              tabId,
              subTabId,
            });
          }}
        />
        <Divider />
      </Box>
      {activeTab.tabId === 1 ? (
        <CustomReportsCreator />
      ) : (
        <CustomReportsSettings />
      )}
    </>
  );
};

export default AddEditCustomReports;
